import { Button } from 'foundations-components/transitional/components/Button';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { Flex } from 'foundations-components/components/Flex';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OpenPQLButton = props => {
  const {
    buttonText,
    modalId
  } = props;
  const {
    openUpgradeModal
  } = useUpgradeModal(modalId);
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    marginBlockStart: "600",
    children: /*#__PURE__*/_jsxs(Button, {
      "data-test-id": "PQL-openButton",
      use: "primary",
      size: "sm",
      onClick: openUpgradeModal,
      margin: "0",
      marginBlockStart: "300",
      children: [/*#__PURE__*/_jsx(LockedIcon, {}), buttonText]
    })
  });
};